import { create } from "zustand";

interface AuthModalState {
  isOpen: boolean;
  message: string | null;
  onSuccess: (() => void) | null;
  open: (options?: { message?: string; onSuccess?: () => void }) => void;
  close: () => void;
}

export const useAuthModal = create<AuthModalState>((set) => ({
  isOpen: false,
  message: null,
  onSuccess: null,
  open: (options) =>
    set({
      isOpen: true,
      message: options?.message ?? null,
      onSuccess: options?.onSuccess ?? null,
    }),
  close: () => set({ isOpen: false, message: null, onSuccess: null }),
}));
